/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Metric_Watchers_Name_RangeInputs */



/**
* | output |
* | --- |
* | "Watchers ({range})" |
*
* @param {Metric_Watchers_Name_RangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_watchers_name_range = /** @type {((inputs: Metric_Watchers_Name_RangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Watchers_Name_RangeInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Watchers (${i?.range})`)
});